<template>
  <div class="announcements">
    <div
      id="announcementCarousel"
      ref="carousel"
      class="carousel slide carousel-fade"
      data-bs-ride="carousel"
    >
      <div class="container">
        <div :class="`carousel-inner ${announcements.length == 1 ? 'px-0' : ''}`">
          <template v-for="(announcement, idx) in announcements" :key="idx">
            <div :class="{ 'carousel-item': true, active: carouselActiveSlide == idx }">
              <svg
                class="bd-placeholder-img bd-placeholder-img-lg d-block w-100"
                width="800"
                height="44"
                xmlns="http://www.w3.org/2000/svg"
                role="img"
                aria-label="Placeholder: First slide"
                preserveAspectRatio="xMidYMid slice"
              >
                <rect width="100%" height="100%" fill="#1D827A"></rect>
              </svg>
              <div class="announcement-text-overlay">
                <span class="announcement-text-content">
                  {{ announcementTexts[idx] }}
                  <CallToAction
                    v-for="(action, idx2) in data.cta[idx]"
                    :key="idx2"
                    class="learn-more"
                    :model="action"
                  />
                </span>
              </div>
            </div>
          </template>
        </div>
      </div>
      <button
        v-if="announcements.length > 1"
        class="carousel-control-prev"
        type="button"
        data-bs-target="#announcementCarousel"
        data-bs-slide="prev"
      >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button
        v-if="announcements.length > 1"
        class="carousel-control-next"
        type="button"
        data-bs-target="#announcementCarousel"
        data-bs-slide="next"
      >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>
  </div>
</template>
<script lang="ts" setup>
import type { AnnouncementBannerModel, CallToActionModel } from '~/models'
import { useEventListener, useWindowSize } from '@vueuse/core'
import get from 'lodash/get'

const announcementStore = useAnnouncementStore()
const props = defineProps<{ announcements: AnnouncementBannerModel[] }>()
const data = {
  cta: props.announcements.map((a) =>
    announcementStore.getListAs<CallToActionModel>(a.elements?.call_to_action?.value)
  )
}

const announcementTexts = ref<string[]>([])

const truncateText = (text: string, maxLength: number) =>
  text.length > maxLength ? text.slice(0, maxLength).trimEnd() + '…' : text

const truncateTexts = () => {
  announcementTexts.value = props.announcements.map((a) => {
    let maxChars
    if (width.value >= 1360) {
      maxChars = 120
    } else if (width.value >= 1140) {
      maxChars = 100
    } else if (width.value >= 430) {
      maxChars = 100
    } else {
      maxChars = 20
    }
    return truncateText(get(a, 'elements.title.value', ''), maxChars)
  })
}

const { width } = useWindowSize()
watch(width, () => {
  truncateTexts()
})

const carousel = ref<HTMLElement | null>(null)
const carouselActiveSlide = ref(0)

const updateActiveSlide = () => {
  if (carousel.value) {
    const activeItem = carousel.value.querySelector('.carousel-item.active')
    const items = Array.from(carousel.value.querySelectorAll('.carousel-item'))
    carouselActiveSlide.value = items.indexOf(activeItem as Element)
  }
}

onMounted(() => {
  if (carousel.value) {
    useEventListener(carousel.value, 'slid.bs.carousel', updateActiveSlide)
    updateActiveSlide()
    truncateTexts()
  }
})
</script>
